import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "debug-num" }
const _hoisted_3 = { class: "debug-num" }
const _hoisted_4 = { class: "debug-num" }
const _hoisted_5 = { class: "debug-num" }
const _hoisted_6 = { class: "debug-num" }
const _hoisted_7 = ["max"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = ["max", "value"]
const _hoisted_10 = { class: "debug-num" }
const _hoisted_11 = { class: "debug-num" }
const _hoisted_12 = { class: "debug-num" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "debug-num" }, " _ ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "debug-num" }, " _ ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("div", {
      id: "container-combat",
      class: _normalizeClass(`combat-container`),
      style: _normalizeStyle({
        filter: `hue-rotate(${_ctx.num.hueRotationDeg}deg) contrast(${_ctx.num.contrast})`,
      })
    }, [
      _createElementVNode("span", {
        class: "player-health dys-size",
        style: _normalizeStyle(_ctx.isActive ? 'opacity:1' : 'transition-duration: 0s')
      }, "Health points: " + _toDisplayString(_ctx.num.playerHealth), 5),
      (_ctx.battles[_ctx.battleName].background !== undefined && _ctx.isActive)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "bg-img",
            id: "bg-img-tuto",
            src: `img/battle/backgrounds/${_ctx.battles[_ctx.battleName].background}${
          _ctx.dyslexic ? '_dyslexic' : ''
        }.png`
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true)
    ], 4),
    _createElementVNode("div", {
      id: "blood-vignette",
      style: _normalizeStyle(`opacity: ${
        _ctx.num.playerHealth <= 1 ? 1 : _ctx.num.playerHealth <= 2 ? 0.2 : 0
      };`)
    }, null, 4),
    (_ctx.showDebug)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "debug-combat",
          style: _normalizeStyle(!_ctx.isActive ? 'pointer-events: none;' : '')
        }, [
          _createElementVNode("span", _hoisted_2, [
            _createElementVNode("button", {
              tabindex: "-1",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reloadCombat && _ctx.reloadCombat(...args)))
            }, "Reload combat")
          ]),
          _createElementVNode("span", _hoisted_3, "audioCurrentTime: " + _toDisplayString(_ctx.currTime().toFixed(3)), 1),
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("button", {
              tabindex: "-1",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.shakeCanvas && _ctx.shakeCanvas(...args)))
            }, "shake canvas")
          ]),
          _createElementVNode("span", _hoisted_5, "nbBullets : " + _toDisplayString(_ctx.bullets.length), 1),
          _createElementVNode("span", _hoisted_6, [
            _createElementVNode("input", {
              tabindex: "-1",
              type: "range",
              style: {"width":"90%"},
              min: "0",
              max: _ctx.audioSources.music_background.getDuration(),
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeAudioTimeEvent && _ctx.changeAudioTimeEvent(...args)))
            }, null, 40, _hoisted_7),
            _hoisted_8,
            _createElementVNode("input", {
              tabindex: "-1",
              type: "range",
              disabled: "true",
              style: {"width":"90%"},
              min: "0",
              max: _ctx.audioSources.music_background.getDuration(),
              value: _ctx.currTime()
            }, null, 8, _hoisted_9)
          ]),
          _createElementVNode("span", _hoisted_10, [
            _createElementVNode("button", {
              tabindex: "-1",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.singerSpawn && _ctx.singerSpawn(...args)))
            }, "singer spawn fake")
          ]),
          _createElementVNode("span", _hoisted_11, [
            _createElementVNode("button", {
              tabindex: "-1",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.singerSpawnReal && _ctx.singerSpawnReal(...args)))
            }, " singer spawn real ")
          ]),
          _createElementVNode("span", _hoisted_12, [
            _createElementVNode("button", {
              tabindex: "-1",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.playerHurt && _ctx.playerHurt(...args)))
            }, "player hurt")
          ]),
          _hoisted_13,
          _hoisted_14,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.num, (numVal, numName) => {
            return (_openBlock(), _createElementBlock("span", {
              class: "debug-num",
              key: numName,
              style: {"margin-right":"10px"}
            }, _toDisplayString(numName.padEnd(25, " ")) + _toDisplayString(`${numVal >= 0 ? " " : ""}${numVal.toFixed(3)}`), 1))
          }), 128)),
          _hoisted_15
        ], 4))
      : _createCommentVNode("", true)
  ]))
}